import LoadingArovyLogo from 'images/integration-logos/ArovyLogo-Blue-Loading-HighlightSweep.svg';
import React from 'react';
export const LoadingArovy = () => React.createElement("div", null,
    React.createElement("img", { alt: '', "aria-hidden": 'true', className: 'arovy-logo', src: LoadingArovyLogo }));
